module.exports = __webpack_public_path__ + "img/withdraw-funds.1c09fa46.svg";